// extracted by mini-css-extract-plugin
export var container = "_ki-0";
export var dotAnimation = "_ki-2";
export var dotsLoading = "_ki-1";